<template>
    <div class="applications-search">
        <sah-input :label="label" type="text" v-model="searchCriteria"></sah-input>
    </div>
</template>

<script>
import {store, SahInput} from "atom";
const {createNamespacedHelpers} = store;
const {mapActions} = createNamespacedHelpers("arcman");
export default {
    name: "applications-search",
    components: {
        SahInput,
    },
    props: {
        label: {type: String},
    },
    watch: {
        searchCriteria(newValue, oldValue) {
            this.searchApplications(newValue);
        },
    },
    data() {
        return {
            searchCriteria: "",
        };
    },
    methods: {
        ...mapActions({
            searchApplications: "SET_CRITERIA_THEN_SEARCH_APPLICATIONS",
            setSearchCriteria: "SET_SEARCH_CRITERIA",
        }),
    },
    mounted() {
        this.setSearchCriteria(this.searchCriteria);
    },
};
</script>
<style lang="scss" scoped>
.applications-search::v-deep {
    @apply w-full;
}
</style>
